// extracted by mini-css-extract-plugin
module.exports = {"container":"PinLevelPermissionCheckbox_container__a8tYh","checkbox":"PinLevelPermissionCheckbox_checkbox__OzTpw","inactive":"PinLevelPermissionCheckbox_inactive__1ddof"};